import { combineReducers } from '@reduxjs/toolkit';
import currentUser from './currentUser';
const rootReducer = combineReducers({
    currentUser,
});
export default rootReducer;
